import { v4 as uuidV4 } from 'uuid'
import { CREATE_DRAFT } from 'ducks/drafts2/constants'
import { buildNewConversationDraftDefaults } from 'ducks/drafts2/util'
import { selectRawTicket } from 'selectors/tickets/byId/selectRawTicket'
import { doSendDraftToServer } from './doSendDraftToServer'

export function doCreateDraft(ticketId, draftType, draftFields) {
  return (dispatch, getState) => {
    const state = getState()
    let draftDefaults
    if (ticketId === 'new') {
      draftDefaults = buildNewConversationDraftDefaults(draftType)
    } else {
      const ticket = selectRawTicket(state, ticketId)
      draftDefaults =
        draftType === 'note' ? ticket.noteDefaults : ticket.draftDefaults
    }

    const fields = {
      ...draftDefaults,
      ...draftFields,
      draftType,
    }
    const isOnlyUpdatingRecipients =
      'to' in draftFields && Object.keys(draftFields).length === 1

    if (draftDefaults) {
      fields.defaultsSet = true
      fields.defaultsSetOnCreate = true
    }
    // catch a case when defaults don't set proper "to"
    // except when the "to" field is emptied by the user
    if (
      !isOnlyUpdatingRecipients &&
      fields.draftType === 'reply' &&
      (!fields.to || fields.to.length === 0)
    ) {
      delete fields.defaultsSet
      delete fields.defaultsSetOnCreate
      fields.defaultsAbortedOnCreate = true
    }
    const draftId = uuidV4()

    dispatch({
      type: CREATE_DRAFT,
      data: { draftId, ticketId, draftType, fields },
    })
    dispatch(doSendDraftToServer(draftId, ticketId))
  }
}
